import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Female = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="female icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 17C9 8.71573 15.7157 2 24 2C32.2843 2 39 8.71573 39 17C39 25.2843 32.2843 32 24 32C15.7157 32 9 25.2843 9 17ZM24 0C14.6112 0 7 7.61116 7 17C7 26.0531 14.0766 33.4535 23 33.9711V40H16V42H23V48H25V42H32V40H25V33.9711C33.9234 33.4535 41 26.0531 41 17C41 7.61116 33.3888 0 24 0Z"
    />
  </svg>
)
